import { render, staticRenderFns } from "./MarginListUpload.vue?vue&type=template&id=2267db25&scoped=true"
import script from "./MarginListUpload.vue?vue&type=script&lang=js"
export * from "./MarginListUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2267db25",
  null
  
)

export default component.exports